import { Link } from "react-router-dom";

export const Logo = () => {
  return (
    <Link
      to="/"
      data-testid="logo-home-link"
      className="flex items-center gap-2.5 group"
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0 transition-transform duration-500 group-hover:rotate-[8deg]"
      >
        <circle cx="18" cy="18" r="13.5" stroke="#D4AF37" strokeWidth="1.1" />
        <path
          d="M13 13.5c0-2 2-3 4-3s4 1 4 3-2 3-4 4-4 2-4 4 2 3 4 3 4-1 4-3"
          stroke="#D4AF37"
          strokeWidth="1.4"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="18" cy="7.5" r="1.2" fill="#D4AF37" />
      </svg>
      <span className="font-heading text-lg sm:text-xl leading-none tracking-tight text-ss-text">
        Soul<span className="text-ss-gold italic"> Skin</span>
      </span>
    </Link>
  );
};
